export default [
  {
    title: "Single Function Adapter",
    items: [
      {
        name: "c0",
        src: require("@/assets/images/adapters/c0-m.jpg"),
        info: [],
      },
      {
        name: "c1",
        src: require("@/assets/images/adapters/c1-m.jpg"),
        info: [],
      },
      {
        name: "c2",
        src: require("@/assets/images/adapters/c2-m.jpg"),
        info: [],
      },
      {
        name: "c3",
        src: require("@/assets/images/adapters/c3-m.jpg"),
        info: [],
      },
      {
        name: "c4",
        src: require("@/assets/images/adapters/c4-m.jpg"),
        info: [],
      },
      {
        name: "c5",
        src: require("@/assets/images/adapters/c5-m.jpg"),
        info: [],
      },
      {
        name: "c6",
        src: require("@/assets/images/adapters/c6-m.jpg"),
        info: [],
      },
      {
        name: "c7",
        src: require("@/assets/images/adapters/c7-m.jpg"),
        info: [],
      },
      {
        name: "c9",
        src: require("@/assets/images/adapters/c9-m.jpg"),
        info: [],
      },
      {
        name: "c10",
        src: require("@/assets/images/adapters/c10-m.jpg"),
        info: [],
      },
    ],
  },
  {
    title: "Multifunction Adapter",
    items: [
      {
        name: "e1",
        info: [],
        src: require("@/assets/images/adapters/e1.jpg"),
      },
    ],
  },
];